import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from '@app/core';
import { SharedModule } from '@app/shared';
import { TuiButton, TuiError, TuiLabel, TuiTextfield } from '@taiga-ui/core';
import {
  TuiButtonLoading,
  TuiCheckbox,
  TuiFieldErrorPipe,
  TuiTextarea,
} from '@taiga-ui/kit';
import { ContactFormService } from '../../services';

@Component({
  selector: 'app-contact-form-section',
  imports: [
    SharedModule,
    TuiButton,
    TuiButtonLoading,
    TuiCheckbox,
    TuiError,
    TuiFieldErrorPipe,
    TuiLabel,
    TuiTextarea,
    TuiTextfield,
  ],
  templateUrl: './contact-form-section.component.html',
  styleUrl: './contact-form-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactFormSectionComponent {
  protected readonly formGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    company: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    message: new FormControl('', [Validators.required]),
    terms: new FormControl(false, [Validators.requiredTrue]),
  });
  protected readonly submitContactForm = this.contactFormService.submit();

  constructor(
    private readonly contactFormService: ContactFormService,
    private readonly notificationsService: NotificationsService,
  ) {}

  protected async onSubmit(): Promise<void> {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      return;
    }
    const formValue = this.formGroup.value;
    if (
      !formValue.firstName ||
      !formValue.lastName ||
      !formValue.company ||
      !formValue.email ||
      !formValue.message
    ) {
      return;
    }
    await this.submitContactForm.mutateAsync({
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      company: formValue.company,
      email: formValue.email,
      message: formValue.message,
    });
    void this.notificationsService.showSuccessNotification(
      'Your message has been sent successfully! We will get back to you soon.',
    );
    this.formGroup.reset({
      firstName: '',
      lastName: '',
      company: '',
      email: '',
      message: '',
      terms: false,
    });
  }
}
